"use client";

import { ActivityDisplayPreview } from "./previews";

type YogaDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function YogaDisplay({ data, participants }: YogaDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="yoga"
      data={data}
      participants={participants}
    />
  );
}
